import { FIF } from "../config/constants";

export const hasMatchFIF = (currentValue: string): boolean =>
  FIF.filter((value: string) => {
    return currentValue.includes(value);
  }).length > 0;
